import { IconButton } from "@material-ui/core";
import { Delete, Edit } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { db, storage } from "../../../../firebase";
import MembersForm from "../../../Pages/CommunityMembers/MembersForm";
import CustomModal from "../../modal/CustomModal";
import "./MemberCard.css";

function MemberCard({ data, setReRender }) {
  const [showModal, setShowModal] = useState(false);
  const [shouldDelete, setShouldDelete] = useState(false);
  const [shouldEdit, setShouldEdit] = useState(false);
  const [choice, setChoice] = useState([]);
  const [modalDialogeDelete, setModalDialogeDelete] = useState(false);
  const [memberFormEdit, setMemberFormEdit] = useState(false);

  useEffect(() => {
    if (!shouldDelete) {
      return;
    }
    const deleteHandler = async () => {
      try {
        const id = data.key;
        await db.collection("Committee").doc(id).delete();
        try {
          await storage.ref(`Committee/${id}`).delete();
        } finally {
          setShouldDelete(false);
          // console.log("deleted");
          setReRender((p) => !p);
        }
      } catch (e) {
        console.log(e);
      }
    };
    deleteHandler();

    // eslint-disable-next-line
  }, [shouldDelete]);

  useEffect(() => {
    if (!shouldEdit) {
      return;
    }
    setShouldEdit(false);
    setMemberFormEdit(true);
    // console.log("edited");
  }, [shouldEdit]);

  return (
    <>
      <div className="member">
        <div>
          <IconButton
            onClick={() => {
              // setShowModal(true);
              // setChoice([shouldEdit, setShouldEdit]);
              setModalDialogeDelete(false);
              setShouldEdit(true);
            }}
          >
            <Edit style={{ color: "white" }} />
          </IconButton>
          <div className="member__imageContainer">
            <img src={data.photo} alt="" />
          </div>
          <IconButton
            onClick={() => {
              setShowModal(true);
              setChoice([shouldDelete, setShouldDelete]);
              setModalDialogeDelete(true);
            }}
          >
            <Delete style={{ color: "white" }} />
          </IconButton>
        </div>
        <b>{`${data.firstName}${data.middleName ? " " + data.middleName : ""} ${
          data.lastName
        }`}</b>
        <p>{data.designation}</p>
        <p>{data.department}</p>
      </div>
      <CustomModal
        message={`Do you want to ${
          modalDialogeDelete ? "DELETE" : "EDIT"
        } data of ${data.firstName}`}
        modalState={[showModal, setShowModal]}
        choiceState={[...choice]}
      />

      <MembersForm
        setReRender={setReRender}
        state={[memberFormEdit, setMemberFormEdit]}
        data={data}
      />
    </>
  );
}

export default MemberCard;
